/*
 *  This file shared.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { EventEmitter, Injectable } from '@angular/core';
import { AbstractControl, FormGroupDirective, NgForm, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router } from '@angular/router';
import { BehaviorSubject, EMPTY, forkJoin, Observable, of, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpService } from './http-service';

import { ConfirmationService } from 'primeng/api';
import { actionPageType } from 'src/app/modules/global-search/global-search.model';
import { HRONE_CONSTANTS } from '../constants/all-hrone.constant';
import { IdentifiersModel, LogonUserDetailModel, monthNames, RequestWorkflowAndStatusModel, TLoginTokenResponse, TokenInfoModel } from '../models/common.models';
import { SnackbarAlertService } from './snackbar-alert.service';

import { DatePipe, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import * as Zip from 'jszip';
import * as jwt from 'jwt-decode';
import { has, isEmpty } from 'lodash';
import moment from 'moment';
import { catchError, first, map, tap } from 'rxjs/operators';
import { TDefaultDomainLogOnTypeDetailsResponse } from 'src/app/authentication/login/login.model';
import { IWorkforceImportListResponseItem, MenuListModel } from 'src/app/main/sidebar/sidebar.model';
import { cityUrls } from 'src/app/modules/core/organization/location/city/city.model';
import { TGeneralEngageSettingResponse, THEME_LIST, TUserThemeInStorage } from 'src/app/modules/enterprise-wall/social-enterpise-wall/social-wall.model';
import { MenuPermissionRightsModel } from 'src/app/modules/global-search/global-search-home/global-search-header/global-search-header.model';
import { TCoreOnboardCheckProcessResponse, TWorkforceSetupSettingResponse } from 'src/app/modules/onboarding-checklist/onboarding-checklist.model';
import { CityModel } from 'src/app/modules/onboarding-config/state-management/onboarding.models';
import { OneOnOneSettingsDetail } from 'src/app/modules/performance/core/1-on-1/1-on-1-home.component';
import { ISettingModel } from 'src/app/modules/recruitment/core/recruitment-setting/budget/budget.component';
import { ExpenseGeneralSettingModel } from 'src/app/modules/request/request.service';
import { SharedStore, TSubscribeModuleResponse } from 'src/app/modules/team/team-dashboards/team-dashboards.model';
import { EmployeeInformation } from 'src/app/modules/variable/search/variable-cards/variable-cards.component';
import { HroneGlobalStateService } from 'src/app/store/global/global-state.service';
import { WidgetModel } from '../components/widgets/widget.model';
import { LoadEnum } from '../models/loading.enum';
import { ConfigurationService } from './configuration.service';
import { SuperMenuModel, SuperUserLoginDetailModel } from './error-handler/super-user-server-error-handler.service';
import { MomentService } from './moment.service';
import { RecruitmentModuleIndependentService } from './recruitment-module-independent.service';
import { UserIdentifierUpdateService } from './user-identifier-update.service';


const companyLogo = 'assets/images/newlogo.svg';
const companyBgImage = 'assets/images/Loginpreview.svg';
const companyHeading = '';
const companySubHeading = '';
const companyFontColor = "#000000";
const favicon = "assets/images/dynamic_images/favicon_hrone.ico";
const flashLoader = "/assets/images/init-loader-1.svg";
const title = "HROne";
const companyLogoGT = "assets/images/dynamic_images/demo.jpg";
const companyBgImageGT = "assets/images/Loginpreview.png";
const companyHeadingGT = "";
const companySubHeadingGT = "";
const companyFontColorGT = "#000000";
const faviconGT = "assets/images/dynamic_images/favicon.ico";
const flashLoaderGT = "assets/images/dynamic_images/loader-2.svg";
const titleGT = 'HRMS';
export interface GroupMember {
  id: number;
  name: string;
  code: string;
  codeName: string;
}

// HROne Enabling happier workplaces

declare function gtag(
  command: 'event' | 'config',
  eventName: string,
  params?: {
    [key: string]: any;
  }
): void;

@Injectable()
export class SharedService {
  searchOpenedListener = new Subject<void>();
  previousUrl: string | null = null;
  sharedStore = new SharedStore<{ subcribedModule: TSubscribeModuleResponse }>();
  isGoogleDisabled: { disabled: boolean, called: boolean, loading: boolean } = { disabled: false, called: false, loading: false };
  isCtcPasswordProtected = true;
  informRoutingToGlobalSearch = new Subject<void>();
  ouApiCache = new Map<string, any>();
  templateId: string | number | null = null;
  display = false;
  flag = false
  profile: string = '';
  superUserLogOnDetails!: SuperUserLoginDetailModel;
  superUserMenuList: SuperMenuModel[] = [];
  phImages = environment.placeholders;
  smartSearchText = 'Search by name or code or designation or email id';
  isRedirectToNotification = false;
  // page call from team or global-search
  actionPageCallFrom: actionPageType = 'global';
  // end
  private readonly dataSubject = new BehaviorSubject<boolean>(false);
  gotoDraftEvent = new EventEmitter()
  isSaveAsDraft = false
  data$ = this.dataSubject.asObservable();
  // Request id with label

  requestId = {
    attendance_regularization_request: 10,
    confirmed_investment_declaration: 37,
    leave_request: 9,
    loan_request: 23,
    on_duty_request: 11,
    proposed_investment_declaration: 25,
    reimbursement_request: 22,
    resignation: 3,
    restricted_holiday_request: 12,
    short_leave_request: 13,
    new_ticket_request: 52,
    expense_advance_request: 70,
    expense: 73,
    job_opening_request: 71,
    change_goal: 60,
    travel_request: 89,
    asset_request: 96,
    variable_request: 93,
    timesheet_request: 120,
    work_plan_request: 118,
    milestone_approval_request: 135,
    mark_attendance: 49,
    project_approval_request: 136,
    change_shift_request: 143,
    leave_encashment_request: 145,
    add_position_request: 148
  }

  moduleNameObj = {
    0: "None",
    1: "Workforce",
    2: "TimeOffice",
    3: "Payroll",
    4: "Performance",
    5: "Expense",
    6: "Helpdesk",
    7: "Asset",
    8: "Training",
    9: "Recruitment",
    10: "Reports",
    11: "Timesheet",
    12: "Travel",
    13: "Integration",
    14: "Incentive",
    15: "AirportEntryPass",
    16: "AdHoc",
    17: "Budget",
    18: "IdCard",
    19: "Core",
    20: "Engage",
    22: "ProjectManagement",
    23: "WorkFromHome",
    24: "WorkforcePlanning"
  }


  isShowAttachment = false;
  previousRouteForCandidateListPage = '';
  expenseGeneralSettings!: ExpenseGeneralSettingModel;


  /* ----- validation msg from requirement team ------ */
  public validationMessages = {
    maxHour: 'Hours should not be greater than 23 !',
    maxMin: 'Minutes should not be greater than 59 !',
    hours: 'Only one digit is allowed after decimal',
    required: 'This field should not be left blank',
    numericOnly: 'Please enter only numeric digits.',
    numericDecimal: 'Please enter decimal numeric digits.',
    numericDecimal2Digits: 'Please enter decimal numeric and max two digits allowed after decimal.',
    alphabetOnly: 'Please enter alphabets only.',
    alphaNumericOnly: 'Please enter only alphanumeric characters',
    allowedCharacters: "a-z, A-Z, 0-9 and (_ @ # $ % & () *.', - ? / : ; ! |) characters are allowed",
    blankSpace: 'Blank spaces are not allowed.',
    spaceNotAllowed: 'Space is not allowed',
    zeroOnlyNotAllowed: 'Zero is not allowed',
    maxLength: 'The maximum character limit is',
    minLength: 'The minimum character limit is',
    maxNumberLength: 'The maximum value allowed is',
    minNumberLength: 'The minimum value allowed is',
    maxLength20: 'Maximum 20 characters are allowed',
    maxLength40: 'Maximum 40 characters are allowed',
    maxLength500: 'Maximum 500 characters are allowed',
    duplicate: 'This code series already exists. Please select a new one and try again.',
    invalidEmail: 'This is not a valid email. Please enter a valid one and try again.',
    invalidWebsite: 'This is not a valid website. Please enter a valid one and try again.',
    validDate: 'This is not a valid date. Please enter a valid date and try again.',
    invalidTime: 'This is not a valid time. Please enter a valid time and try again.',
    invalidDuration: 'This is not a valid duration. Please enter a valid duration and try again.',
    numericOrDecimal: 'Invalid input', //'This is not a valid number.Please enter a valid one and try again.', changed after disccus with meghna bug id ---- 30108
    parAccessDenied: "You do not have permission. Please contact your administrator.",
    parView: "You do not have permission to view. Please contact your administrator.",
    parAdd: "You do not have permission to add. Please contact your administrator.",
    parEdit: "You do not have permission to edit. Please contact your administrator.",
    parUpdate: "You do not have permission to update. Please contact your administrator.",
    parDelete: "You do not have permission to delete. Please contact your administrator.",
    parRemove: "You do not have permission to remove. Please contact your administrator.",
    parInactivate: "You do not have permission to inactivate. Please contact your administrator.",
    pan: 'This is not a valid PAN number.',
    gstin: 'This is not a valid GSTIN number.',
    uan: 'This is not a valid UAN number. Please enter a valid one and try again.',
    passport: 'This is not a valid passport no. Please enter a valid one and try again.',
    passregex: 'Password must be at least 6 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
    aadhar: 'This is not a valid aadhar card number. Please enter a valid one and try again.',
    autoComplete: 'This is not a valid input. Please search a valid one.',
    lessFromDate: 'This date cannot be less than from date.',
    lessStartDate: 'This date cannot be less than start date.',
    valueGreaterThan: 'The value should be greater than',
    invalidRange: 'Duration of date search should be 90 days',
    bothDate: 'Please select both From and To date ',
    SSOIdRegx: 'a-z, A-Z, 0-9 and (_ @ . -) characters are allowed',
    paytmWallet: 'This is not a valid wallet id. Please enter a valid one and try again',
    ipAddressInvalid: 'please enter valid Ip address',
    macAddressInvalid: 'please enter valid mac address',
    uuidInvalid: 'please enter valid UUID',
    isValidUrl: 'please enter valid url',
    numberRange: 'Please enter the digit between 1 to 6',
    allowedCharactersWithApostrophe: "a-z, A-Z, 0-9 and (_ @ # $ % & () *., - ? / : ; ! | ') characters are allowed",
    invalidLatitude: 'Invalid latitude',
    invalidLongitude: 'Invalid longitude',
    invalidFromToInput: 'Invalid range',
    mobile: 'This is not a valid number!',
    specialCharacterOnly: 'Only special characters are allowed',
    numericAndSpecialCharacter: 'Numeric and special characters are allowed',
    specialCharacterAndAlphabet: 'Special character and alphabet are allowed',
    maximumHrs: 'The maximum hour limit is',
    fileName: 'This file name is invalid. Use only letters, numbers, and the special characters [ ] and _',
    allowedAllCharactersExceptSpace: 'space is not allowed',
    allowedCharactersWithoutQuotes: "a-z, A-Z, 0-9 and (_ @ # $ % & () *., - ? / : ; ! |) characters are allowed",
    allowedCharactersWithoutQuotesWithBrackets: "a-z, A-Z, 0-9 and (_ @ # $ % & () *., - ? / : ; ! | [] \" + = < >) characters are allowed",
    allowedCharactersWithSquareBrackets: "a-z, A-Z, 0-9 and (_ @ # $ % & () *.', - ? / : ; ! |[]) characters are allowed",
    maximumEmailsAllowed: 'Maximum number of emails allowed is',
    httpHeaderName: "a-z, A-Z, 0-9 and (! # $ % & ' * + - . ^ _ ` | ~) characters are allowed. Spaces are not allowed."
  };
  /* ----- */

  // custom badges list

  customBadges = [
    { path: '/assets/images/badges/custombadge/badge_1.png', color: '#ffc540', imageName: 'badge_1', focus: false },
    { path: '/assets/images/badges/custombadge/badge_2.png', color: '#7bff96', imageName: 'badge_2', focus: false },
    { path: '/assets/images/badges/custombadge/badge_3.png', color: '#615fff', imageName: 'badge_3', focus: false },
    { path: '/assets/images/badges/custombadge/badge_4.png', color: '#ce9fed', imageName: 'badge_4', focus: false },
    { path: '/assets/images/badges/custombadge/badge_5.png', color: '#548754', imageName: 'badge_5', focus: false },
    { path: '/assets/images/badges/custombadge/badge_6.png', color: '#2e4d34', imageName: 'badge_6', focus: false },
    { path: '/assets/images/badges/custombadge/badge_7.png', color: '#5fe5ff', imageName: 'badge_7', focus: false },
    { path: '/assets/images/badges/custombadge/badge_8.png', color: '#ed9fbd', imageName: 'badge_8', focus: false },
  ];

  // End custom badges
  public moduleId: number | undefined;

  tokenInfo!: TokenInfoModel;
  logOnUserDetails!: LogonUserDetailModel;
  logOnUserIdentifiers: IdentifiersModel = {
    organizationKeyOne: 0,
    organizationKeyTwo: 0
  };

  // tslint:disable-next-line: no-use-before-declare
  matcher = new MyErrorStateMatcher();

  rawMenus: MenuListModel[] = [];
  rawMenusWithActions: RawMenuActionInterface[] = [];
  whiteLabels: { [key: string]: string } = {};

  // HRONE CONSTANTS
  MENU_CODES = HRONE_CONSTANTS.MENU_CODES;
  imageSources = HRONE_CONSTANTS.imageSources;
  formIds = HRONE_CONSTANTS.formIds;
  moduleIds = HRONE_CONSTANTS.moduleIds;
  workFlowIds = HRONE_CONSTANTS.workFlowIds;
  ouIds = HRONE_CONSTANTS.ouIds;
  letterTemplateIds = HRONE_CONSTANTS.letterTemplateIds;
  // END HRONECONSTANTS

  timeZone = 'GMT+0530';

  confirmDialogData = {
    message: 'All data will be lost.',
    header: 'Do you want to close the window ?',
  };

  pendingStatusText = "Request is already pending";

  minValidDate = new Date(1753, 1, 1);
  maxValidDate = new Date(9999, 12, 31);

  companyDetails = {
    companyLogo: this._config.configData?.isDeployOnGT ? companyLogoGT : companyLogo,
    companyBgImage: this._config.configData?.isDeployOnGT ? companyBgImageGT : companyBgImage,
    companyHeading: this._config.configData?.isDeployOnGT ? companyHeadingGT : companyHeading,
    companySubHeading: this._config.configData?.isDeployOnGT ? companySubHeadingGT : companySubHeading,
    companyFontColor: this._config.configData?.isDeployOnGT ? companyFontColorGT : companyFontColor,
    companyLink: null,
    favicon: this._config.configData?.isDeployOnGT ? faviconGT : favicon,
    title: this._config.configData?.isDeployOnGT ? titleGT : title,
    flashLoader: !this._config.configData?.isDeployOnGT ? flashLoader : flashLoaderGT
  };
  displayHdFeedback = false;
  feedbackArr: FeedbackDetails[] = [];
  dashboardRegimeRes = {
    financialYear: '',
    showTaxRegime: false,
    taxRegime: 'NEW',
    considerConfirmInvestment: false,
    showCrossOnTaxRegime: false
  };
  isPulseRatingShow = false;
  commonLoginPopupData: CommonLoginPopupDataInterface[] = [];

  pulseFeedbackArr: PulseFeedbackDataInterface[] = [];
  pulseFeedbackData: PulseFeedbackDataInterface | null = null;

  managerWidgetList: WidgetModel[] = [];
  hrWidgetList: WidgetModel[] = [];
  teamManagerWidgetList: WidgetModel[] = [];
  monthNameArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  import_pageList: IWorkforceImportListResponseItem[] = [];

  notiCount = 0;
  isShowPassword = false;

  isPRoductTourShown = false;
  supportUserInfo: { [key: string]: any } | null = null;
  isCompanyLogin = false;
  isPoweredByFlag = new BehaviorSubject(false);


  taskCounter = null;
  isVisibleUSerAnalytics = true;
  logOnTypeDetails!: TDefaultDomainLogOnTypeDetailsResponse;
  teamDirectList: TeamDirectListModel[] = [];
  taskData: TaskDataInterface[] = [];
  betaValue: any;
  bulkArchiveSetting = {
    archiveDays: null,
    archivalType: '',
    isEnableBulkArchive: false
  };

  userLoggedOut: BehaviorSubject<boolean> = new BehaviorSubject(false);
  analyticsStorage: any = {};
  didUserLogout = false;

  isDirectoryFilterApplicable = false;
  isProfilePrivate = false;
  accessType = 'A'
  showNewOrgChart: boolean | null = null;
  isFromGoalFeedback = false;
  SubscribeModule!: TSubscribeModuleResponse;
  bgClass: string = '';
  cityDropdown: Array<{ key: string, value: string, text: string }> = [];
  hrHanbookList = [];
  tokens = {
    teams: false,
    google: false
  }
  isGetImportPagesCalled: boolean = false;
  isGetImportPagesCalledInProgress: boolean = false;
  reportStatusMsg = "";
  isCurrentEmployeePriviledged: boolean = false;
  inboxHideHeaderTop = false;
  userLicenseInfo!: IUserLicenseInfo;
  engageSetting: { engageSettingResponse: TGeneralEngageSettingResponse; loaded: boolean, loading: boolean } = { loaded: false, loading: false, engageSettingResponse: {} as TGeneralEngageSettingResponse }
  teamActionsList: any[] = [];
  viewAs = 'E';
  showAniversaryAnim = false;
  showBirthDayAnim = false;
  getDefaultDomainInformationBs = new BehaviorSubject<TDefaultDomainLogOnTypeDetailsResponse | null>(null);
  resetSingletonData = new Subject<void>();
  coreValueName = 'Core values';
  commmonSettingsList: ICommonsetting[] = [];
  newInsightCrossMarkObj = {
    FV: false,
    OT: false,
    PT: false,
    RE: false,
    AT: false
  };
  teamIndirectList: any[] = [];
  isReviewCalculationVisible = false;
  import_pageList_enterprise: WorkforceImportListModel[] = [];
  hrDeskActionList: { moduleName: string; moduleId: number; menus: MenuPermissionRightsModel[] }[] = [];
  processes_searchList: MenuPermissionRightsModel[] = [];
  reportList: EnterpriseReportMenuListModel[] = [];
  websiteVersion = '';
  onboardingAccess = false;
  navigateToDocument = false;
  digiSignLicenseInfo = { active: false, apiCalled: false };
  isEmailVerified = 'N';
  isNumberVerified = 'N';
  pinnedMenus: { [key: string]: any }[] = [];
  generalSettingDetails = [];
  pmsSettingDetails: PmsSettingType[] = [];
  minAllowedDate = new Date('1753-01-01');
  resetSelectedModuleId = new Subject<void>();
  recruitmentSettingsList: ISettingModel[] = [];
  isAnimationOnitTriggered = false;
  messageChannel = 'W';
  orgChartEnableType = 0;
  helpDeskSettingsCache: { loaded: boolean; showSLAStatus: boolean } = { loaded: false, showSLAStatus: false };

  monthsList = [
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
  ];
  private readonly versionSubject = new BehaviorSubject<boolean>(this.getInitialVersion());
  version$ = this.versionSubject.asObservable();
  private readonly auditTrailVersionSubject = new BehaviorSubject<boolean>(this.getAuditTrailInitialVersion());
  auditTrailVersion$ = this.auditTrailVersionSubject.asObservable();
  hrDesk_Available_Searches_List: any[] = [];
  hrDesk_Action_List: MenuPermissionRightsModel[] = [];
  hrDesk_Import_Page_List: IWorkforceImportListResponseItem[] = [];
  teams_Import_Page_List: IWorkforceImportListResponseItem[] = [];
  oneOnoneSettingsList: OneOnOneSettingsDetail | null = null;
  loadEnum = LoadEnum;
  isReportsLoading: LoadEnum = this.loadEnum.loaded;
  showPublishedDate = true;
  engageSettingPromise: Promise<void> | null = null;
  get legoOrgId(): string | null { return localStorage.getItem('legoOrgId'); }
  menusListToHideFromSidebar = [1205, 1206, 1178, 1186, 1187, 1208, 1146, 1075, 893, 892, 1293, 1337, 1334, 1389, 959, 831, 726, 472, 146, 513, 48, 379, 345, 1512];

  constructor(
    public _httpService: HttpService,
    public router: Router,
    public _snackBar: SnackbarAlertService,
    public _confirmDialog: ConfirmationService,
    public _sanitizer: DomSanitizer,
    public _config: ConfigurationService,
    public datepipe: DatePipe,
    public _httpClient: HttpClient,
    public _location: Location,
    public _globalState: HroneGlobalStateService,
    private readonly _rMIS: RecruitmentModuleIndependentService,
    private readonly _identifierUpdateService: UserIdentifierUpdateService,
    private readonly _momentService: MomentService
  ) {
    this._httpService.updateSignalRAuthTokenSubject.subscribe(() => {
      this.getTokenInfo();
    });
    this.setBgClass();

    this._identifierUpdateService.identifierUpdate$.subscribe(identifiers => {
      if (identifiers) {
        this.logOnUserIdentifiers.organizationKeyOne = identifiers.organizationKeyOne;
        this.logOnUserIdentifiers.organizationKeyTwo = identifiers.organizationKeyTwo;
      }
    });
  }

  isEmailBlocked(): boolean {
    const stored = localStorage.getItem('isEmailBlocked');
    return stored ? JSON.parse(stored) : Boolean(this.logOnUserDetails?.isEmailBlocked);
  }

  syncReportVersionSetting(): void {
    this._globalState.getWorkforceSetupSetting(123).subscribe(res => {
      if (res?.status === 'Y') {
        this.setVersion(true);
      }
    });
  }

  orgChartAccessRight(): void {
    this._globalState.getWorkforceSetupSetting(55).subscribe({
      next: (res) => {
        const showNew = res?.status === 'Y';
        this.showNewOrgChart = res?.status === 'D' ? null : showNew;
        if (this.showNewOrgChart !== null) {
          this.isFeatureAvailable(211).then((res) => {
            if (res) {
              this.getChartAccessType();
            }
          });
        }
      },
      error: () => {
        this.showNewOrgChart = null;
      },
    });
  }

  getChartAccessType(): void {
    this._httpService.Get('/api/payroll/workforce/planning/setting').subscribe(res => {
      this.orgChartEnableType = res.orgEnableType ?? 0;
    })
  }

  reset() {
    this.import_pageList_enterprise = [];
    this.hrDeskActionList = [];
    this.processes_searchList = [];
    this.reportList = [];
    this.managerWidgetList = [];
    this.hrWidgetList = [];
    this.teamManagerWidgetList = [];
    this.analyticsStorage = {};
    this.didUserLogout = true;
    this.isGoogleDisabled = { disabled: false, called: false, loading: false };
    this.isGetImportPagesCalled = false;
    this.getDefaultDomainInformationBs.next(null);
    this.resetSingletonData.next();
    this.showAniversaryAnim = false;
    this.showBirthDayAnim = false;
    this.isAnimationOnitTriggered = false;
    this.newInsightCrossMarkObj = {
      FV: false,
      OT: false,
      PT: false,
      RE: false,
      AT: false
    }
  }

  PoweredBy() {

    this._globalState.getWorkforceSetupSetting(27)
      .subscribe(res => {
        this.isPoweredByFlag.next(res?.isActive ?? false);
      })
  }

  removeDuplicatesMembers(members: GroupMember[]) {
    const uniqueMembers = members.filter((member: GroupMember, index: number, self: GroupMember[]) =>
      index === self.findIndex((m: GroupMember) => m.id === member.id)
    );

    return uniqueMembers;

  }

  getPoweredBy() {
    return this.isPoweredByFlag.asObservable();
  }

  public getCount(url: string, object: any, value: string, event?: Event) {
    if (event) { event.stopPropagation(); }
    this._httpService.Get(url).subscribe(response => {
      object[value] = response;
    });
  }

  allowNumbersOnly(event: KeyboardEvent) {
    const invalidChars = [
      '-', '+', 'e', '=', '~', ';', '/', ',', '?', '[', ']', '|', '\\', ':', '"', '<', '>', '*',
      '(', ')', '_', '{', '}', '!', '@', '#', '$', '%', '^', '&', '\'', 'E'
    ];
    const input = event.target as HTMLInputElement;
    if (invalidChars.includes(event.key) ||
      (input.value.length > 9 && event.key !== 'Backspace')) {
      event.preventDefault();
    }
  }

  allowIntegerOnly(event: KeyboardEvent) {
    const invalidChars = [
      '-', '+', 'e', '=', '~', ';', '/', ',', '?', '[', ']', '|', '\\', ':', '"', '<', '>', '*',
      '(', ')', '_', '{', '}', '!', '@', '#', '$', '%', '^', '&', '\'', '.', 'E'
    ];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  validateSpecialCharactersForFileName(name: string): boolean {
    const regex = /[/\\:"*?<>|]/;
    return regex.test(name);
  }


  minutesConvertor(minutes: number) {
    const min = + minutes;
    if (min > 0) {
      const hours = Math.floor(min / 60);
      const minutes = min % 60;
      return hours + 'H' + ":" + minutes + 'M';
    } else {
      return '00:00'
    }
  }

  hoursConvertor(hours: number) {
    return +hours * 60;
  }

  public checkShowMore(listLength: number, totalRecords: number) {
    if (listLength < totalRecords) {
      return true;
    } else {
      return false;
    }
  }

  public validateMinMax(min: number, max: number) {
    if (min === 0 || max === 0) {
      return true;
    }

    if (Number(min) > Number(max)) {
      return false;
    } else {
      return true;
    }

  }

  isNumber(evt: KeyboardEvent) {
    const charCode = evt.which || evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  compareMultiselectFn(a: any, b: any) {
    return a && b && a.id === b.id;
  }
  compareMultiselectFn2(a: any, b: any) {
    return a && b && a.Id === b.Id;
  }
  compareMultiselectFn3(a: any, b: any) {
    return a && b && a.Key === b.Key;
  }
  compareMultiselectFn4(a: any, b: any) {
    return a && b && a.key === b.key;
  }
  compareMultiselectFn5(a: any, b: any) {
    return a && b && a === b;
  }
  compareMultiselect(a: any, b: any) {
    return a && b && a.key === b.key;
  }
  compareMultiselectPlain(a: any, b: any) {
    return a && b && a === b;
  }

  compareMultiselectFnForObject(a: any, b: any) {
    return a && b && JSON.stringify(a) === JSON.stringify(b);
  }

  removeMultiSelectFilter(selectFilter: any, appliedFilter: any, propKey: string, value: any) {
    selectFilter[propKey] = selectFilter[propKey].filter((data: any) => data.key !== value);
    appliedFilter[propKey] = appliedFilter[propKey].filter((data: any) => data.key !== value);
  }

  removeStatusFilter(selectFilter: any, appliedFilter: any, propKey: string) {
    selectFilter[propKey] = false;
    appliedFilter[propKey] = false;
  }

  removeAllFilter(selectFilter: any, appliedFilter: any, skeleton: any) {
    const sf = Object.keys(selectFilter);
    const af = Object.keys(appliedFilter);
    Object.keys(skeleton).forEach(key => {
      const sfi = sf.indexOf(key);
      const afi = af.indexOf(key);
      if (sfi >= 0) {
        selectFilter[key] = skeleton[key];
      }
      if (afi >= 0) {
        appliedFilter[key] = skeleton[key];
      }
    });
  }

  removeCheckboxListFilter(checkboxList: any[], appliedFilter: any, key: string, value: any) {
    appliedFilter[key] = appliedFilter[key].filter((data: any) => data.value !== value);
    const fi = checkboxList.findIndex(data => data.value === value);
    if (fi >= 0) {
      checkboxList[fi].status = false;
    }
  }

  getUserDetails() {
    this._httpService.Get('/api/LogOnUser/LogOnUserDetail').subscribe(response => {

      localStorage.setItem('logOnUserDetails', JSON.stringify(response));

      this.logOnUserDetails = response;
      if (this.logOnUserDetails?.identifier) {
        this.logOnUserIdentifiers = this.logOnUserDetails.identifier;
      }
    });
  }

  convertFormGroupNullValueToEmptyString(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      if (formGroup.get(key)?.value === null) {
        formGroup.get(key)?.setValue('');
      }
    });
  }

  convertNullToEmptyString(data: any) {
    Object.keys(data).forEach(key1 => {

      if (data[key1] === null) {
        data[key1] = '';
      } else if (Array.isArray(data[key1])) {
        for (const item of data[key1]) {
          Object.keys(item).forEach(key2 => {
            if (item[key2] === null) {
              item[key2] = '';
            }
          });
        }
      } else if (typeof data[key1] === 'object' && data[key1] !== null) {
        Object.keys(data[key1]).forEach(key2 => {
          if (data[key1][key2] === null) {
            data[key1][key2] = '';
          }
        });
      }

    });
  }

  getIdentifier(type: 1 | 2, empInfo: any) {
    let key = '';
    let orgKey;

    if (type === 1) {
      orgKey = this.logOnUserIdentifiers.organizationKeyOne;
    } else if (type === 2) {
      orgKey = this.logOnUserIdentifiers.organizationKeyTwo;
    }

    if (orgKey && empInfo) {

      if (orgKey === 1) {
        key = empInfo['company'];
      } else if (orgKey === 14) {
        key = empInfo['businessUnit'];
      } else if (orgKey === 4) {
        key = empInfo['department'];
      } else if (orgKey === 7) {
        key = empInfo['subDepartment'];
      } else if (orgKey === 2) {
        key = empInfo['designation'];
      } else if (orgKey === 3) {
        key = empInfo['grade'];
      } else if (orgKey === 8) {
        key = empInfo['level'];
      } else if (orgKey === 9) {
        key = empInfo['region'];
      } else if (orgKey === 10) {
        key = empInfo['branch'];
      } else if (orgKey === 11) {
        key = empInfo['subBranch'];
      }
    }

    return key;
  }

  getIdentifierName(type: 1 | 2, empInfo: any) {
    let key = '';
    let orgKey;

    if (type === 1) {
      orgKey = this.logOnUserIdentifiers.organizationKeyOne;
    } else if (type === 2) {
      orgKey = this.logOnUserIdentifiers.organizationKeyTwo;
    }

    if (orgKey && empInfo) {

      if (orgKey === 1) {
        key = empInfo['companyName'];
      } else if (orgKey === 14) {
        key = empInfo['businessUnitName'];
      } else if (orgKey === 4) {
        key = empInfo['departmentName'];
      } else if (orgKey === 7) {
        key = empInfo['subDepartmentName'];
      } else if (orgKey === 2) {
        key = empInfo['designationName'];
      } else if (orgKey === 3) {
        key = empInfo['gradeName'];
      } else if (orgKey === 8) {
        key = empInfo['levelName'];
      } else if (orgKey === 9) {
        key = empInfo['regionName'];
      } else if (orgKey === 10) {
        key = empInfo['branchName'];
      } else if (orgKey === 11) {
        key = empInfo['subBranchName'];
      }
    }

    return key;
  }

  BASIC_CONST = {
    employeeCode: {
      prop: 'employeeCode'
    },
    salutationName: {
      prop: 'salutation'
    },
    firstName: {
      prop: 'firstName'
    },
    middleName: {
      prop: 'middleName'
    },
    lastName: {
      prop: 'lastName'
    },
    dateOfBirth: {
      prop: 'dateOfBirth',
      date: true
    },
    genderName: {
      prop: 'genderId'
    },
    bloodGroupName: {
      prop: 'bloodGroupCode'
    },
    nationalityName: {
      prop: 'nationality'
    },
    mobileNo: {
      prop: 'mobileNo'
    },
    officialEmail: {
      prop: 'officialEmail'
    },
    dateOfJoining: {
      prop: 'dateOfJoining',
      date: true
    },
    employeeType: {
      prop: 'employeeTypeId'
    },

    employeeStatus: {
      prop: 'employeeStatusId'
    },
    dateOfConfirmation: {
      prop: 'dateOfConfirmation',
      date: true,
    },
    dateOfResignation: {
      prop: 'dateOfResignation',
      date: true,
    },
    dateOfLeaving: {
      prop: 'dateOfLeaving',
      date: true,
    },
    dateOfSettlement: {
      prop: 'dateOfSettlement',
      date: true,
    },

    otherStatusName: {
      prop: 'otherStatusId'
    },
    otherStatusDate: {
      prop: 'otherStatusDate',
      date: true
    },
    otherStatusRemarks: {
      prop: 'otherStatusRemarks'
    },

    businessUnit: {
      prop: 'businessUnitCode'
    },
    companyName: {
      prop: 'companyCode'
    },
    departmentName: {
      prop: 'departmentCode'
    },
    subDepartmentName: {
      prop: 'subDepartmentCode'
    },
    designationName: {
      prop: 'designationCode'
    },
    branchName: {
      prop: 'branchCode'
    },
    subBranchName: {
      prop: 'subBranchCode'
    },
    gradeName: {
      prop: 'gradeCode'
    },
    levelName: {
      prop: 'levelCode'
    },
    reportingManager: {
      prop: 'reportingManagerId',
      add: 'reportingManagerCode'
    },
    functionalManager: {
      prop: 'functionalManagerId',
      add: 'functionalManagerCode'
    },
    skillType: {
      prop: 'skillTypeId'
    },
    regionName: {
      prop: 'regionCode'
    },
    biometricId: {
      prop: 'biometricId'
    },
    internationalCode: {
      prop: 'internationalCode'
    },
    dimensionOneCode: {
      prop: 'dimensionOneCode'
    },
    dimensionTwoCode: {
      prop: 'dimensionTwoCode'
    },
    dimensionThreeCode: {
      prop: 'dimensionThreeCode'
    },
    dimensionFourCode: {
      prop: 'dimensionFourCode'
    },
    dimensionFiveCode: {
      prop: 'dimensionFiveCode'
    },
    dimensionSixCode: {
      prop: 'dimensionSixCode'
    },
    employeeSeparationReason: {
      prop: 'employeeSeparationReasonId'
    },
    organizationSeparationReason: {
      prop: 'organizationSeparationReasonId'
    },
    settlementSeparationReason: {
      prop: 'settlementSeparationReasonId'
    },
    alumniStatus: {
      prop: 'alumniStatus'
    },
    blacklistReason: {
      prop: 'blacklistReasonId'
    },
    blacklistComments: {
      prop: 'blacklistComments'
    }
  };

  getIdentifierOne(): TIdentifierKey {
    let key: TIdentifierKey = 'designation';
    if (this.logOnUserIdentifiers?.organizationKeyOne) {
      if (this.logOnUserIdentifiers.organizationKeyOne === 1) {
        key = 'company';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 14) {
        key = 'businessUnit';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 4) {
        key = 'department';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 7) {
        key = 'subDepartment';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 3) {
        key = 'grade';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 8) {
        key = 'level';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 9) {
        key = 'region';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 10) {
        key = 'branch';
      } else if (this.logOnUserIdentifiers.organizationKeyOne === 11) {
        key = 'subBranch';
      }
    }

    return key;
  }

  getIdentifierTwo(): TIdentifierKey {
    let key: TIdentifierKey = 'grade';
    if (this.logOnUserIdentifiers?.organizationKeyTwo) {
      if (this.logOnUserIdentifiers.organizationKeyTwo === 1) {
        key = 'company';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 14) {
        key = 'businessUnit';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 4) {
        key = 'department';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 7) {
        key = 'subDepartment';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 2) {
        key = 'designation';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 8) {
        key = 'level';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 9) {
        key = 'region';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 10) {
        key = 'branch';
      } else if (this.logOnUserIdentifiers.organizationKeyTwo === 11) {
        key = 'subBranch';
      }
    }

    return key;
  }

  getIdentifierLabel(type: number) {
    let key = 'Designation';
    if (this.logOnUserIdentifiers?.organizationKeyOne && this.logOnUserIdentifiers?.organizationKeyTwo) {
      let orgKey = this.logOnUserIdentifiers.organizationKeyOne;
      if (type === 2) {
        orgKey = this.logOnUserIdentifiers.organizationKeyTwo;
      }

      if (orgKey === 1) {
        key = 'Company';
      } else if (orgKey === 14) {
        key = 'Business unit';
      } else if (orgKey === 4) {
        key = 'Department';
      } else if (orgKey === 7) {
        key = 'Sub department';
      } else if (orgKey === 3) {
        key = 'Grade';
      } else if (orgKey === 8) {
        key = 'Level';
      } else if (orgKey === 9) {
        key = 'Region';
      } else if (orgKey === 10) {
        key = 'Branch';
      } else if (orgKey === 11) {
        key = 'Sub branch';
      }
    }

    return key;
  }

  public getModuleId() {
    this.router.url.split('/').forEach(menuname => {
      switch (menuname) {
        case 'workforce': this.moduleId = 1;
          break;
        case 'timeoffice': this.moduleId = 2;
          break;
        case 'payroll': this.moduleId = 3;
          break;
        case 'performance': this.moduleId = 4;
          break;
        case 'expense': this.moduleId = 5;
          break;
        case 'recruitment': this.moduleId = 9;
          break;
        case 'asset': this.moduleId = 7;
          break;
        case 'work-from-home': this.moduleId = 23;
          break;
      }
    });
    return this.moduleId;
  }
  public getModuleName(moduleId: number): string {
    if (this.moduleNameObj.hasOwnProperty(moduleId)) {
      return this.moduleNameObj[moduleId as keyof typeof this.moduleNameObj];
    }
    return ''
  }

  getGlobalSearcheEmployees(): string {
    let searchedEmployees = JSON.parse(sessionStorage.getItem('globalSearchedEmployeesInNewTab') ?? '[]');
    searchedEmployees = ['M', 'U'].includes(this.accessType) || this.viewAs == 'H' ? JSON.parse(sessionStorage.getItem('searchedEmployeeToViewAsHROrManager') ?? '[]') : searchedEmployees;
    let searchedEmployeesString = '';
    if (searchedEmployees) {
      searchedEmployeesString = searchedEmployees.map((e: { id: number }) => e.id).join(',');
    }
    return searchedEmployeesString;
  }

  getOnbehalfEmployee() {
    const empId = localStorage.getItem('onBehalfEmployee');
    return Number(empId);
  }

  pScrollToTop(ps: any) {
    if (ps.directiveRef) {
      ps.directiveRef.scrollToTop(0, 0);
    }
  }

  pScrollToBottom(ps: any) {
    if (ps.directiveRef) {
      ps.directiveRef.scrollToBottom(0, 0);
    }
  }

  pScrollToXY(ps: any, y: number) {
    if (ps.directiveRef) {
      ps.directiveRef.scrollTo(0, y);
    }
  }

  goToActionHome() {
    if (this.actionPageCallFrom === 'global') {
      this.goToGSearchHome();
    } else if (this.actionPageCallFrom === 'team') {
      this.goToTeamHome();
    }
  }

  goToGSearchHome() {
    setTimeout(() => { this.router.navigate(['/app/processes/search']); }, 100);

  }

  goToTeamHome() {
    setTimeout(() => { this.router.navigate(['/app/team/myteam']); }, 100);
  }

  redirectIfNotRights() {
    setTimeout(() => {
      if (this.logOnUserDetails?.employeeStatusId == 7) {
        this.router.navigate(['app/inbox']);
      } else {
        this.router.navigate(['/app']);
      }
    }, 110);

  }



  dateChange(control: AbstractControl) {
    if (!control.value) {
      control.setValue('');
    }
    control.updateValueAndValidity();
  }

  downloadUnploadedFile(path: any) {
    if (path &&
      (path.indexOf('https://') !== -1
        || path.indexOf('http://') !== -1)) {
      window.location.href = path;

    }
  }

  getRequestStatus(empId: number, flowId: number, payCode?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const subtype = payCode ?? '0';
      const url = '/api/core/Workflow/Request/Status/' + empId + '/' + flowId + '/' + subtype;
      this._httpService.Get(url).subscribe(resposne => {
        resolve(resposne);
      }, () => {
        reject(new Error('Error'));
      });
    });
  }

  getRequestWorkflowAndStatus(empId: number, flowId: number, subType?: '0' | '1' | '0,1'): Promise<RequestWorkflowAndStatusModel> {

    return new Promise((resolve) => {

      const sub_type = subType ?? '0';
      const statusUrl = '/api/core/Workflow/Request/Status/' + empId + '/' + flowId + '/' + sub_type;
      const workFlowUrl = '/api/core/ValidateWorkflow/' + empId + '/' + flowId;
      const statusRequest = this._httpService.Get(statusUrl);
      const workFlowRequest = this._httpService.Get(workFlowUrl);

      const requestStatus: RequestWorkflowAndStatusModel = {
        isInvalid: true,
        reason: ''
      };

      forkJoin([workFlowRequest, statusRequest]).toPromise()
        .then(response => {
          if (response![0].validationType === '0') {
            if (response![1] === 0) {
              requestStatus.isInvalid = true;
              requestStatus.reason = 'Your last request is pending, you cannot initiate new request';
            } else {
              requestStatus.isInvalid = false;
            }
          } else {
            requestStatus.isInvalid = true;
            requestStatus.reason = response![0].message;
          }
          resolve(requestStatus);
        }).catch(() => {
          resolve(requestStatus);
        });

    });
  }

  removeNewLine(str: string) {
    const rstr = str.replace(/\r\n|[\n\r\u2028\u2029]+/g, " ");
    return rstr;
  }

  preventEnterKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  private compareArrays(newArray: any[], preArray: any[]): boolean {
    if (newArray.length !== preArray.length) {
      return true;
    }
    for (let i = 0; i < newArray.length; i++) {
      if (this.compareFormData(newArray[i], preArray[i], true)) {
        return true;
      }
    }
    return false;
  }

  private compareObjects(newItem: any, preItem: any): boolean {
    return this.compareFormData(newItem, preItem, true);
  }

  private comparePrimitives(newValue: any, preValue: any, newData: any, preData: any, key: string): boolean {
    if (typeof newValue === 'string') {
      newData[key] = newValue.trim();
      newValue = newData[key];
    }
    if (typeof preValue === 'string') {
      preData[key] = preValue.trim();
      preValue = preData[key];
    }
    return (newValue || preValue) && (newValue !== preValue);
  }

  compareFormData(newData: any, preData: any, isRecursive?: boolean): boolean {
    if (!preData) {
      return true;
    }

    try {
      const keys = Object.keys(newData);
      for (const key of keys) {
        if (!has(preData, key)) {
          continue;
        }

        const newValue = newData[key];
        const preValue = preData[key];

        let isChanged = false;
        if (Array.isArray(newValue) && Array.isArray(preValue)) {
          isChanged = this.compareArrays(newValue, preValue);
        } else if (typeof newValue === 'object' && newValue !== null && typeof preValue === 'object' && preValue !== null) {
          isChanged = this.compareObjects(newValue, preValue);
        } else {
          isChanged = this.comparePrimitives(newValue, preValue, newData, preData, key);
        }

        if (isChanged) {
          return true;
        }
      }

      if (!isRecursive) {
        this._snackBar.Alert('Please fill some data', '3');
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  getAppVersion() {
    this._httpService.GetWithoutHeader('/api/Default/ApplicationVersion').subscribe((response: any) => {
      if (response?.length) {
        this.websiteVersion = response[0].websiteVersion;
        const localV = localStorage.getItem('versionId');
        localStorage.setItem('versionId', response[0].versionId);
        if (localV && localV != response[0].versionId) {
          location.reload();
        }
      }
    });
  }

  private getDefaultLogo(response: any): string {
    return response?.fileVirtualPath ?? (this.isDeployedOnGT ? companyLogoGT : companyLogo);
  }

  private getDefaultHeading(response: any): string {
    const heading = response?.enterpriseBackgroundEntity?.backgroundHeading;
    return heading ?? (this.isDeployedOnGT ? companyHeadingGT : companyHeading);
  }

  private getDefaultSubHeading(response: any): string {
    const subHeading = response?.enterpriseBackgroundEntity?.backgroundSubheading;
    return subHeading ?? (this.isDeployedOnGT ? companySubHeadingGT : companySubHeading);
  }

  private getDefaultBgImage(response: any): string {
    const bgImage = response?.enterpriseBackgroundEntity?.backgroundImageVirtualPath;
    return bgImage ?? (this.isDeployedOnGT ? companyBgImageGT : companyBgImage);
  }

  getComapanyDetails(domainCode: string) {
    this.companyDetails = {
      companyLogo: '',
      companyBgImage: 'assets/images/Progress-Bar-line.gif',
      companyHeading: '',
      companySubHeading: '',
      companyFontColor: '',
      companyLink: null,
      favicon: favicon,
      title: title,
      flashLoader: flashLoader
    };
    this.getDefaultDomainInformationOb(domainCode).subscribe((response: any) => {
      const entity = response?.enterpriseBackgroundEntity;
      this.companyDetails.companyLogo = this.getDefaultLogo(response);
      this.companyDetails.companyHeading = this.getDefaultHeading(response);
      this.companyDetails.companySubHeading = this.getDefaultSubHeading(response);
      this.companyDetails.companyFontColor = entity?.backgroundFontColor ?? companyFontColor;
      this.companyDetails.companyLink = entity?.enterprisePath ?? null;
      this.companyDetails.companyBgImage = this.getDefaultBgImage(response);
    }, () => {
      this.getDefaultCompDetails();
    });
  }

  getDefaultDomainInformationOb(domainCode: string): Observable<TDefaultDomainLogOnTypeDetailsResponse> {
    const cache = this.getDefaultDomainInformationBs.getValue();
    if (!cache) {
      return this._httpService.GetWithoutHeader('/api/Default/' + domainCode).pipe(
        tap((response: TDefaultDomainLogOnTypeDetailsResponse) => {
          this.getDefaultDomainInformationBs.next(response);
        })
      );
    }
    else {
      this.getDefaultDomainInformationBs.next(cache);
      return this.getDefaultDomainInformationBs.asObservable().pipe(
        map(response => response as TDefaultDomainLogOnTypeDetailsResponse)
      );
    }
  }



  getDefaultCompDetails() {
    const isDeployOnGT = this._config.configData?.isDeployOnGT ?? false;
    this.companyDetails = {
      companyLogo: isDeployOnGT ? companyLogoGT : companyLogo,
      companyBgImage: isDeployOnGT ? companyBgImageGT : companyBgImage,
      companyHeading: isDeployOnGT ? companyHeadingGT : companyHeading,
      companySubHeading: isDeployOnGT ? companySubHeadingGT : companySubHeading,
      companyFontColor: isDeployOnGT ? companyFontColorGT : companyFontColor,
      companyLink: null,
      favicon: isDeployOnGT ? faviconGT : favicon,
      title: isDeployOnGT ? titleGT : title,
      flashLoader: isDeployOnGT ? flashLoaderGT : flashLoader
    };
  }

  getMonthName(monthNo: number): string {
    if (monthNo) {
      return monthNames.short[monthNo as keyof typeof monthNames.short];
    } else {
      return '';
    }
  }

  goToPage(page: 'inbox' | 'request' | 'profile') {

    if (page === 'inbox') {
      this.router.navigate(['app/inbox']);
    } else if (page === 'request') {
      this.router.navigate(['app/request/initiatedrequest']);
    } else if (page === 'profile') {
      this.router.navigate(['/app/myprofile/profile']);
    }

  }

  getTokenInfo() {
    let tokenInfo: TokenInfoModel | null;
    const auth = JSON.parse(localStorage.getItem('authlogin') ?? '{}');
    const token = auth?.access_token ? auth.access_token : '';
    try {
      tokenInfo = jwt(token);
    } catch (error) {
      tokenInfo = null;
    }

    this.tokenInfo = tokenInfo as TokenInfoModel;

  }

  isFeatureAvailable(featureId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._globalState.validateFeature(featureId)
        .subscribe(response => {
          if (response?.isActive) {
            resolve(true);
          } else {
            resolve(false);
          }
        },
          () => {
            reject(new Error('false'));
          });
    });
  }

  getPulseData(data: { requestId: number }) {
    this._httpService.Get('/api/engage/employee/Weightage/Rating/Details/' + data.requestId).subscribe(response => {
      if (response) {
        this.pulseFeedbackData = response;
        this.isPulseRatingShow = true;
      }
    });
  }

  stopPropagation(event: Event) {
    try { event.stopPropagation(); } catch (err) { }
  }

  checkDate(fromDate: Date | string, toDate: Date | string) {
    const fD = new Date(fromDate);
    const tD = new Date(toDate);
    const a = moment([fD.getFullYear(), (fD.getMonth()), fD.getDate()]);
    const b = moment([tD.getFullYear(), (tD.getMonth()), tD.getDate()]);
    return 90 >= b.diff(a, 'days');
  }

  checkMenuAccess(menuId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const url = '/api/core/MenuAccess';
      const payload = {
        "menuType": "",
        "parentKey": 9999,
        "menuId": menuId,
        "includeMenu": false
      };

      this._httpService.Post(url, payload).toPromise().then((res: MenuAccessInterface[]) => {
        const list = res ?? [];
        if (list.findIndex(ele => ele.menuId == menuId) >= 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch(() => {
        reject(new Error('false'));
      })
    });

  }

  getImportPages(): Observable<IWorkforceImportListResponseItem[]> {
    const bs = new BehaviorSubject(this.import_pageList);
    if (this.isGetImportPagesCalled || this.isGetImportPagesCalledInProgress) return bs.asObservable();
    this.isGetImportPagesCalledInProgress = true;
    this.import_pageList = [];
    const args = {
      'moduleId': 0,
      'importName': '',
      'forPin': 0
    };
    this._httpService.Post('/api/workforce/import/ImportList', args)
      .subscribe({
        next: response => {
          if (response) {
            this.import_pageList = response;
            bs.next(this.import_pageList);
            this.isGetImportPagesCalled = true;
            this.isGetImportPagesCalledInProgress = true;
          }
        },
        error: () => {
          this.isGetImportPagesCalledInProgress = true;
        }
      });
    return bs.asObservable();
  }
  getGoogleMeetFeatured(): any {
    return new Promise((resolve, reject) => {
      this._httpService.Get(`/api/core/feature/Validate/${207}`).subscribe(res => {
        if (res) {
          resolve(res.isActive);
        } else {
          resolve(0);
        }
      }, err => reject(new Error(err)));
    });
  }


  getNotiCount(forceCall = false) {
    const fStatus = localStorage.getItem("notificationFetched");
    if (fStatus && !forceCall) {
      this.notiCount = JSON.parse(fStatus);
      return;
    }
    this._httpService.Get('/api/core/Dashboard/Notification/count').subscribe(res => {
      this.notiCount = Number(res);
      this.notiCount > 0 && localStorage.setItem("notificationFetched", this.notiCount.toString())
    });
  }

  public namingConvention(value: string): string {
    const lowerC = value.toLowerCase();
    const changedData = lowerC.charAt(0).toUpperCase() + lowerC.substring(1);
    return changedData;
  }

  timeDiffCalc(dateFuture: any, dateNow: any): string {
    let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

    let days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;

    let hours: any = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    let minutes: any = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    let seconds: any = Math.floor(diffInMilliSeconds) % 60;

    if (days > 0) {
      days = days * 24;
      hours = days + hours;
    }
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    const difference = [minutes, seconds].join(' : ');
    return difference;
  }
  isScreenLockInIdle(): Promise<number | false> {
    return new Promise((resolve, reject) => {
      this._globalState.getWorkforceSetupSetting(22).subscribe(res => {
        if (res && (res.status !== '-1' && res.status !== 'N')) {
          resolve(Number(res.status) ? Number(res.status) * 60 : 600);
        } else {
          resolve(false);
        }
      }, err => {
        reject(new Error(err));
      })
    });
  }

  getEmployeeLateCount(calenderData: { presentStatus: string | null }[]): number {
    return calenderData?.filter(e => e.presentStatus == 'Late' || e.presentStatus == 'Early').length;
  }

  isGlobalSettingEnable(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._globalState.getWorkforceSetupSetting(id).subscribe(res => {
        if (res && res.status === 'Y') {
          resolve(true);
        } else {
          resolve(false);
        }
      }, err => {
        reject(new Error(err));
      })
    });
  }

  getInboxCounter(moduleId: number): void {
    this.isVisibleUSerAnalytics = true;

    this._httpService.Get('/api/inbox/taskCount/' + moduleId).subscribe(res => {
      this.taskCounter = res ?? null;

    }
    )
  }

  convertDateToTime(date: any): string {
    let time = date;
    if (date instanceof Date) {
      const hour = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours();
      const minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      time = hour + ':' + minutes;
    }
    return time;
  }

  convertTimeToDate(time: any): Date {
    const date = new Date();
    if (typeof time == 'string') {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), Number(time.substring(0, 2)), Number(time.substring(3)));
    }
    return time;
  }

  getCodeSeries(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = `/api/core/CodeSeriesApplicability/${id}`;
      this._httpService.Get(url)
        .subscribe(
          (response) => {
            resolve(response);
          },
          () => {
            reject(new Error('null'));
          });

    });
  }


  getVerificationStatus(key: string, value: any, bgvVerificationDetails: any[]): string {
    if (!bgvVerificationDetails.length) {
      return '2';
    }
    const verDetail = bgvVerificationDetails.filter(det => det.originalFieldName === key);
    if (key == 'DOB' && value) {
      value = this.datepipe.transform(value, 'yyyy-MM-dd');
    }

    if (verDetail.length) {
      const verifiedFromAadhar = verDetail.find(det => (det.aadhaarKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      const verifiedFromPan = verDetail.find(det => (det.panKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      const verifiedFromBankAccount = verDetail.find(det => (det.bankAccountKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      const verifiedFromDL = verDetail.find(det => (det.dlKycFieldValue || '').toString().trim().toLowerCase() == (value || '').toString().trim().toLowerCase());
      if (verifiedFromAadhar || verifiedFromPan || verifiedFromBankAccount || verifiedFromDL) {
        return '0';
      } else if (!verDetail[0].aadhaarKycFieldValue && !verDetail[0].panKycFieldValue && !verDetail[0].bankAccountKycFieldValue && !verDetail[0].dlKycFieldValue) {
        return '2';
      } else {
        return '1';
      }
    } else {
      return '2';
    }
  }

  private normalizeValue(value: string): string {
    return (value || '').toString().trim().toLowerCase();
  }

  private findVerificationSource(verDetail: any[], value: string, fieldName: string): boolean {
    return verDetail.some(det => this.normalizeValue(det[fieldName]) === this.normalizeValue(value));
  }

  private getVerificationSources(verDetail: any[], value: string) {
    return {
      aadhar: this.findVerificationSource(verDetail, value, 'aadhaarKycFieldValue'),
      pan: this.findVerificationSource(verDetail, value, 'panKycFieldValue'),
      bankAccount: this.findVerificationSource(verDetail, value, 'bankAccountKycFieldValue'),
      dl: this.findVerificationSource(verDetail, value, 'dlKycFieldValue')
    };
  }

  private getTooltipMessage(sources: { aadhar: boolean; pan: boolean; bankAccount: boolean; dl: boolean }): string {
    if (sources.aadhar && sources.pan) {
      return 'Fetched from Aadhar,PAN';
    }
    if (sources.aadhar) {
      return 'Fetched from Aadhar';
    }
    if (sources.pan) {
      return 'Fetched from PAN';
    }
    if (sources.bankAccount) {
      return 'Fetched from Bank Account';
    }
    if (sources.dl) {
      return 'Fetched from DL';
    }
    return 'Not available';
  }

  private hasAnyKycField(verDetail: any[]): boolean {
    const first = verDetail[0];
    return !!(first?.aadhaarKycFieldValue || first?.panKycFieldValue || first?.bankAccountKycFieldValue || first?.dlKycFieldValue);
  }

  private getUnverifiedMessage(verDetail: any[]): string {
    const first = verDetail[0];
    const unverifiedValue = first?.aadharValue || first?.panValue || first?.bankAccountValue || first?.dlValue || '';
    return `Not verified: ${unverifiedValue}`;
  }

  getVerificationTooltip(key: string, value: any, bgvVerificationDetails: any[]): string {
    if (!value) {
      return '';
    }
    if (!bgvVerificationDetails.length) {
      return 'Not available';
    }

    const verDetail = bgvVerificationDetails.filter(det => det.originalFieldName === key);
    if (!verDetail.length) {
      return 'Not available';
    }

    let normalizedValue = value;
    if (key === 'DOB' && value) {
      normalizedValue = this.datepipe.transform(value, 'yyyy-MM-dd');
    }

    const sources = this.getVerificationSources(verDetail, normalizedValue);
    const hasAnySource = sources.aadhar || sources.pan || sources.bankAccount || sources.dl;

    if (hasAnySource) {
      return this.getTooltipMessage(sources);
    }

    if (!this.hasAnyKycField(verDetail)) {
      return 'Not available';
    }

    return this.getUnverifiedMessage(verDetail);
  }

  getTeamDirectList(): Promise<TeamDirectListModel[]> {
    return new Promise((resolve, reject) => {
      const req_data = { reportId: 1, reportingTeam: 'RM', teamSearch: '', pagination: { pageNumber: 1, pageSize: 99999 } };
      if (this.teamDirectList.length) {
        resolve(this.teamDirectList);
      } else {
        this._httpService.Post('/api/workforce/Team/Direct/Indirect', req_data)
          .subscribe(
            (response) => {
              this.teamDirectList = response ?? [];
              resolve(this.teamDirectList);
            },
            () => {
              reject(new Error('[]'));
            });
      }
    });
  }

  getTaskData(refresh = false): void {
    if (!this.taskData.length || refresh) {
      this._globalState.getWorkflowInboxSettingList(refresh).subscribe(response => {
        this.taskData = response ?? []
      });
    }
  }


  // code for read new-beta.json
  readNewBetaJson(): any {
    return new Promise(() => {
      this._httpClient.get('/assets/json/new-beta.json')
        .toPromise()
        .then((data: any) => {
          this.betaValue = data;
        });
    });
  }
  bindNewBetaOnMenu(res: { menuId: number, isNewBeta?: string }[]): void {
    if (this.betaValue) {
      res.forEach((obj) => {
        const isBeta = this.betaValue?.beta[0]?.arrMenuId?.includes(obj.menuId);
        const isNew = this.betaValue?.new[0]?.arrMenuId?.includes(obj.menuId);
        obj.isNewBeta = isBeta ? 'BETA' : isNew ? 'NEW' : '';
      });
    }
  }
  bindNewBetaOnModule(response: { moduleId: number, isNewBeta?: string }[]): void {
    if (this.betaValue) {
      response.forEach((obj) => {
        const isBeta = this.betaValue?.beta[0]?.arrModuleId?.includes(obj.moduleId);
        const isNew = this.betaValue?.new[0]?.arrModuleId?.includes(obj.moduleId);
        obj.isNewBeta = isBeta ? 'BETA' : isNew ? 'NEW' : '';
      });
    }
  }
  bindNewBetaOnAccessRights(res: { accessRightId: number, isNewBeta?: string }[]): void {
    if (this.betaValue) {
      res.forEach((obj) => {
        const isBeta = this.betaValue?.beta[0]?.accessRightId?.includes(obj.accessRightId);
        const isNew = this.betaValue?.new[0]?.accessRightId?.includes(obj.accessRightId);
        obj.isNewBeta = isBeta ? 'BETA' : isNew ? 'NEW' : '';
      });
    }
  }

  getApplicatbility(orgIds = '1,2,3,4,7,8,9,10,11,14') {
    return new Promise((resolve, reject) => {
      this._httpService.Get(`/api/core/CodeSeries/OrganizationPriority/${orgIds}`).subscribe(response => {
        const data = response ?? [];
        resolve(data)
      }, () => reject(new Error('[]')));
    });
  }

  getbulkarchiveSetting() {
    const URL = `/api/core/autoarchive`;
    this._httpService.Get(URL).subscribe(res => {
      if (res) {
        this.bulkArchiveSetting = res;
      }
    });
  }

  getHelpDeskSettings(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.helpDeskSettingsCache.loaded) {
        resolve(this.helpDeskSettingsCache.showSLAStatus);
        return;
      }

      this._httpService.Get('/api/helpdesk/setting/policy/Helpdesk/Setting').subscribe(res => {
        this.helpDeskSettingsCache.loaded = true;
        this.helpDeskSettingsCache.showSLAStatus = res?.showSLAStatus || false;
        resolve(this.helpDeskSettingsCache.showSLAStatus);
      });
    })
  }

  setDirectoryFilter(isDir: boolean) {
    this.isDirectoryFilterApplicable = isDir;
  }

  get getDirectoryFilter() {
    return this.isDirectoryFilterApplicable ? 1 : 0;
  }

  setIsProfilePrivate(isDir: boolean) {
    this.isProfilePrivate = isDir;
  }

  get getIsProfilePrivate() {
    return this.isProfilePrivate;
  }

  getEngageSetting(): Promise<void> {
    if (!isEmpty(this.engageSetting.engageSettingResponse)) {
      return Promise.resolve();
    }
    if (this.engageSettingPromise) {
      return this.engageSettingPromise;
    }
    this.engageSettingPromise = new Promise((resolve, reject) => {
      this.engageSetting.loaded = true;
      this.engageSetting.loading = true;
      this._globalState.getGeneralSettings().subscribe(
        {
          next: (res: TGeneralEngageSettingResponse) => {
            this.engageSetting.engageSettingResponse = res;
            if (res) {
              this.isShowAttachment = res.isShowAttachment;
              this.setDirectoryFilter(res.wallApplicability);
            }
            this.engageSetting.loading = false;
            this.engageSettingPromise = null;
            resolve();
          },
          error: () => {
            this.engageSetting.loading = false;
            this.engageSettingPromise = null;
            resolve();
          }
        }
      );
    });

    return this.engageSettingPromise;
  }

  get isDeployedOnGT(): boolean {
    return Boolean(this._config.configData && this._config.configData.isDeployOnGT);
  }

  refreshRecentSearchedProfileData(): void {
    const recentsearchList = JSON.parse(localStorage.getItem('recent_profile_searches') ?? '[]');
    if (recentsearchList?.length) {
      recentsearchList.forEach((search: { menuId: number }, index: number) => {
        const ind = (this.rawMenus ?? []).findIndex((menu: { menuId: number }) => menu.menuId == search.menuId);
        if (ind == -1) {
          recentsearchList.splice(index, 1);
        }
      });
      localStorage.setItem('recent_profile_searches', JSON.stringify(recentsearchList));
    }
  }
  setEmployeeNameFromCode(list: { employeeId: number, employeeName: string, employeeCode: string }[]): { key: number, value: string }[] {
    return list.map(employee => ({ key: employee.employeeId, value: `${employee.employeeName} #${employee.employeeCode}` }))
  }
  getUserThemeFromStorage(): TUserThemeInStorage {
    localStorage.removeItem('selectedThemeColorIndex');
    const theme: string = localStorage.getItem('selectedTheme') ?? '';
    let userThemeFromStorage: TUserThemeInStorage = theme ? JSON.parse(theme) : { default: 0, user: null, hr: null };
    let count = 0;
    while (typeof userThemeFromStorage === 'string' && count < 10) {
      userThemeFromStorage = JSON.parse(userThemeFromStorage);
      count++;
    }
    return userThemeFromStorage;
  }
  getCurrentThemeId(): number {
    const userThemeFromStorage: TUserThemeInStorage = this.getUserThemeFromStorage();
    let colorIndex = 0;
    if (userThemeFromStorage.user) {
      colorIndex = userThemeFromStorage.user;
    }
    else if (userThemeFromStorage.hr) {
      colorIndex = userThemeFromStorage.hr;
    }
    return colorIndex;
  }
  setBgClass(): void {
    let colorIndex = this.getCurrentThemeId();
    colorIndex = colorIndex > THEME_LIST.length ? 0 : colorIndex;
    const userThemeFromStorage: TUserThemeInStorage = this.getUserThemeFromStorage();
    this.setThemeToStorage(userThemeFromStorage);
    const newbgClass = THEME_LIST[colorIndex];
    const finalclass = Object.keys(newbgClass)[0];
    if (document.body.classList.contains('myycolor')) {
      document.body.removeAttribute('class');
    }
    document.body.setAttribute('class', finalclass)

  }
  setThemeToStorage(userThemeFromStorage: TUserThemeInStorage) {
    localStorage.setItem('selectedTheme', JSON.stringify(userThemeFromStorage));
  }

  async generateZip(promisList: Array<Promise<TDownloadPromise>>, zipName: string): Promise<void> {
    const zip = new Zip();
    Promise.all<Promise<TDownloadPromise>[]>(promisList).then((blobs) => {
      blobs.forEach(({ promise, folderPath, fileName }, index) => {
        const newFileName = fileName.split("/")[fileName.split("/").length - 1];
        zip?.folder(folderPath)?.file(newFileName, promise);
        if (blobs.length === index + 1) {
          zip.generateAsync({ type: 'blob' })
            .then(function (zipBlob) {
              const zipBlobUrl = URL.createObjectURL(zipBlob);
              const downloadLink = document.createElement('a');
              downloadLink.href = zipBlobUrl;
              downloadLink.download = zipName + '.zip';
              downloadLink.textContent = 'Download Zip';
              document.body.appendChild(downloadLink);
              downloadLink.click();
            })
            .catch(function (error) {
              console.error('Error creating zip:', error);

            });
        }
      });
    });
  }
  generatePathList(response: IZipDownloadResponse, appendReceiptCode = false) {
    const folders = Array.isArray(response.folders) ? response.folders : [{ fileList: response.fileList ?? [], folderName: response.folderName ?? '' }];
    const promiseList: Array<Promise<TDownloadPromise>> = [];
    for (const folder of folders) {
      for (const file of folder.fileList) {
        const dbFileName = typeof file === 'string' ? file : file.dbFileName;
        const b = response.blobBasePath + '/' + dbFileName + response.accessToken;
        let displayFileName = dbFileName;
        if (appendReceiptCode && typeof file !== 'string' && file.receiptCode) {
          const dotIndex = dbFileName.lastIndexOf('.');
          displayFileName = dotIndex > -1
            ? `${dbFileName.substring(0, dotIndex)}_${file.receiptCode}${dbFileName.substring(dotIndex)}`
            : `${dbFileName}_${file.receiptCode}`;
        }
        promiseList.push(this.returnPromise(b, folder.folderName, displayFileName));
      }
    }
    return promiseList;
  }
  async returnPromise(url: string, folderPath: string, fileName: string): Promise<TDownloadPromise> {
    const response = await fetch(url);
    const blobData = await response.blob();
    return { promise: blobData, folderPath: folderPath, fileName };
  }

  getCityPermanent() {
    if (this.cityDropdown.length) {
      return;
    }
    const payload = {
      "cityCode": "",
      "stateCode": "",
      "countryCode": "",
      "cityStatus": "1",
      "pagination": {
        "pageNumber": 0,
        "pageSize": 9999
      }
    }
    this._httpService.Post(cityUrls.search, payload).subscribe(response => {
      this.cityDropdown = [];
      if (response) {
        response.forEach((x: CityModel) => {
          this.cityDropdown.push({ 'key': x.cityCode, 'value': [x.cityName, x.stateName, x.countryName].join(','), 'text': x.cityName })
        })
      }
    });
  }

  navigateToCurrentRoute(fromSearch = false): void {
    const location = this._location.path();
    const selectedHRDesk = localStorage.getItem('lastRedirectSearch');
    this.resetSelectedModuleId.next();
    if (this.router.url.includes('from=action') || fromSearch || this.router.url.includes('/app/processes/search/imports') || this.router.url.includes('key=openSettings')) {
      if (selectedHRDesk) {
        this.router.navigateByUrl(selectedHRDesk);
        localStorage.removeItem('lastRedirectSearch');
      }
      else {
        const moduleId = new URLSearchParams(location.split('?')[1]).get('moduleId');
        const url = '/app/processes/search?moduleId=' + moduleId + '&redirectTo=0&openedFrom=pin';
        this.router.navigateByUrl(url);
      }
    } else {
      const { url } = this.router;
      if (url.includes('/app/processes/search/talentpool')) {
        const params = new URLSearchParams(url.split('?')[1] || '');
        const newView = (Number(params.get('view')) ?? 0) + 1;
        const baseUrl = url.split('?')[0];
        const newUrl = `${baseUrl}?view=${newView}`;
        this.router.navigateByUrl(newUrl);
      } else {
        this.router.navigateByUrl(location);
      }
    }
  }
  isEmployeePriviledged(employeeId: number | 'candidate' | null): Observable<boolean> {
    if (employeeId === 'candidate') {
      return this._httpService.Get(`/api/core/pii/isprivilegeuser`);
    }
    return this._httpService.Get(employeeId ? `/api/core/pii/isprivilegeuser/${employeeId}` : `/api/core/pii/isprivilegeuser/${this.logOnUserDetails.employeeId}`);
  }

  getUserLicenseInfo(): Promise<IUserLicenseInfo> {
    return new Promise((resolve, reject) => {
      if (this.userLicenseInfo) {
        resolve(this.userLicenseInfo);
      } else {
        this._httpService.Get('/api/UserLicense/info').subscribe((res: IUserLicenseInfo) => {
          this.userLicenseInfo = res;
          resolve(this.userLicenseInfo);
        });
      }
    });
  }

  getCommonSettingsList(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.commmonSettingsList.length) {
        resolve();
        return;
      }
      this.callCommonSettingService().subscribe((data: ICommonsetting[]) => {
        this.commmonSettingsList = data;
        resolve();
      })
    });
  }
  callCommonSettingService(): Observable<ICommonsetting[]> {
    return this._httpClient.get('assets/json/common-settings-list.json') as Observable<ICommonsetting[]>
  }

  canDisplaySettings(menuId: number, flag = false): ICommonsetting[] {
    const settingList = this.commmonSettingsList.filter(config => config.menuId == menuId);
    if (settingList.length) {
      settingList.forEach(setting => {
        switch (setting.settingType) {
          case 'WO':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => flag ? item.accessRightId === 632 : item.accessRightId === 210) >= 0;
            break;
          case 'TO':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 245) >= 0;
            break;
          case 'Payroll':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 420) >= 0;
            break;
          case 'Helpdesk':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 1111) >= 0;
            break;
          case 'ProjectMgmt':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 2074) >= 0;
            break;
          case 'Engage':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 632) >= 0;
            break;
          case 'PMS':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 571) >= 0;
            break;
          case 'Asset':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 971) >= 0;
            break;
          case 'RMS':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 821) >= 0;
            break;
          case 'Expense':
            setting['hasAccess'] = this.rawMenusWithActions.findIndex(item => item.accessRightId === 718) >= 0;
            break;
          default:
            setting['hasAccess'] = false;
        }
      });
    }
    return settingList.find(setting => setting.hasAccess) ? settingList : [];
  }

  getModules(): Observable<TSubscribeModuleResponse> {
    return this._globalState.subscribeModule();
  }

  getTeamIndirectList(): Promise<any> {
    return new Promise((resolve, reject) => {
      const req_data = { reportId: 2, reportingTeam: 'RM', teamSearch: '', pagination: { pageNumber: 1, pageSize: 99999 } };
      if (this.teamIndirectList.length) {
        resolve(this.teamIndirectList);
      } else {
        this._httpService.Post('/api/workforce/Team/Direct/Indirect', req_data)
          .subscribe(
            (response) => {
              this.teamIndirectList = response ?? [];
              resolve(this.teamIndirectList);
            },
            () => {
              reject(new Error('[]'));
            });
      }
    });
  }

  getNewPmsSetting(): void {
    if (this.pmsSettingDetails.length) return
    const url = '/api/pms/setting/general/Extensions';
    this._httpService.Get(url).subscribe((res: PmsSettingType[]) => {
      if (res?.length) {
        this.isReviewCalculationVisible = Boolean(res.find((ele: PmsSettingType) => ele.generalSettingId === 104 && ele.status === 'Y'));
        this.pmsSettingDetails = res;
      }
    });
  }
  sendData(data: boolean): void {
    this.dataSubject.next(data);
  }
  resetData(): void {
    this.dataSubject.next(false);
  }
  onRedirectToOnboarding() {
    const url = '/api/core/onboard/CheckProcess';
    this._httpService.Get(url).subscribe((res: TCoreOnboardCheckProcessResponse) => {
      let pageNumber: number = res?.selectedOnPageNumber ? res?.selectedOnPageNumber : 1;
      if (res.selectedOnPageNumber == 4) {
        localStorage.setItem('isModuleSelection', JSON.stringify(true));
        this.router.navigate(['/app/onboarding-checklist', pageNumber, res?.selectedSegmentTypeId]);
      }
      else {
        localStorage.setItem('isGetStart', JSON.stringify(true))
        this.router.navigate(['/onboarding-config', pageNumber])
      }
    })
  }

  getOnboardingSetting(): void {
    this._globalState.getWorkforceSetupSetting(68).subscribe((res: TWorkforceSetupSettingResponse | null) => {
      this.onboardingAccess = Boolean(this.rawMenus.find(item => item.menuId === 7)) && res?.status === 'Y';
    })
  }

  getExpenseSettings(): Observable<ExpenseGeneralSettingModel> {
    if (this.expenseGeneralSettings) {
      return of(this.expenseGeneralSettings);
    }
    return this._httpService.Get('/api/Expense/GeneralSetting').pipe(
      tap((res: ExpenseGeneralSettingModel) => {
        if (res) {
          this.expenseGeneralSettings = res;
        }
      })
    );
  }

  getIsGoogleDisabled(): Observable<Partial<TWorkforceSetupSettingResponse>> {
    if (this.isGoogleDisabled.loading) return EMPTY;
    if (this.isGoogleDisabled.called) return of({ status: this.isGoogleDisabled.disabled ? 'Y' : 'N' });
    this.isGoogleDisabled.loading = true;
    return this._globalState.getWorkforceSetupSetting(77) as Observable<Partial<TWorkforceSetupSettingResponse>>;
  }

  checkDigiSignLicense(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.digiSignLicenseInfo.apiCalled) {
        resolve();
      } else {
        this.isFeatureAvailable(247).then(res => {
          this.digiSignLicenseInfo.apiCalled = true;
          this.digiSignLicenseInfo.active = res;
          if (!this.digiSignLicenseInfo.active) {
            this.isFeatureAvailable(264).then(res => {
              this.digiSignLicenseInfo.apiCalled = true;
              this.digiSignLicenseInfo.active = res;
              resolve();
            });
          }
          resolve();
        });
      }
    });
  }

  getModuleIconNames(moduleId: string | number): { icon: string, activeIcon: string } {
    switch (moduleId.toString()) {
      case '24': return { icon: 'fa-light fa-calendar-users', activeIcon: 'fa-light fa-calendar-users' };
      case '22': return { icon: 'fa-light fa-list-dropdown', activeIcon: 'fa-light fa-list-dropdown' };
      case '20': return { icon: 'fa-regular fa-party-horn', activeIcon: 'fa-regular fa-party-horn' };
      case '1': return { icon: 'fa-regular fa-user-group', activeIcon: 'fa-regular fa-user-group' };
      case '2': return { icon: 'fa-regular fa-clock', activeIcon: 'fa-regular fa-clock' };
      case '3': return { icon: 'fa-light fa-money-bill-wave', activeIcon: 'fa-light fa-money-bill-wave' };
      case '4': return { icon: 'fa-regular fa-arrow-trend-up', activeIcon: 'fa-regular fa-arrow-trend-up' };
      case '5': return { icon: 'fa-regular fa-receipt acc-icon', activeIcon: 'fa-regular fa-receipt acc-icon' };
      case '6': return { icon: 'fa-regular fa-headphones', activeIcon: 'fa-regular fa-headphones' };
      case '7': return { icon: 'fa-regular fa-laptop-mobile acc-icon', activeIcon: 'fa-regular fa-laptop-mobile acc-icon' };
      case '9': return { icon: 'fa-regular fa-briefcase', activeIcon: 'fa-regular fa-briefcase' };
      default: return { icon: 'fa-regular fa-calendars', activeIcon: 'fa-regular fa-calendars' };
    }
  }

  getMenuIds(moduleId: string | number): number {
    switch (moduleId.toString()) {
      case '20': return 187;
      case '1': return 38;
      case '2': return 94;
      case '3': return 54;
      case '4': return 410;
      case '5': return 504;
      case '6': return 369;
      case '7': return 736;
      case '9': return 573;
      case '23': return 1000;
      case '22': return 1391;
      case '24': return 1444;
      default: return 0;
    }
  }
  getRecruitmentSetting(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.recruitmentSettingsList.length) {
        resolve(null);
      } else {
        this._rMIS.getRecruitmentGeneralSettingList()
          .subscribe(
            (response: ISettingModel[]) => {
              this.recruitmentSettingsList = response ?? [];
              resolve(null);
            },
            () => {
              reject(new Error('null'));
            });
      }
    });
  }
  getMaskedMobileNumber(): string {
    const mobile = this.logOnUserDetails?.mobileNo || '';
    if (mobile.length <= 4) return mobile;
    return 'X'.repeat(mobile.length - 4) + mobile.slice(-4);
  }

  getMaskedEmail(): string {
    const email = this.logOnUserDetails?.officialEmail || '';
    const atIndex = email.indexOf('@');
    if (atIndex < 0) return '';
    if (atIndex <= 4) {
      return 'X'.repeat(atIndex) + email.slice(atIndex);
    }
    return 'X'.repeat(4) + email.slice(4);
  }


  private getInitialVersion(): boolean {
    const saved = localStorage.getItem('reportVersionSet');
    return saved ? JSON.parse(saved) : false;
  }

  toggleVersion(): void {
    const newVersion = !this.versionSubject.value;
    this.setVersion(newVersion);
  }

  setVersion(version: boolean): void {
    this.versionSubject.next(version);
    localStorage.setItem('reportVersionSet', JSON.stringify(version));
  }

  get currentVersion(): boolean {
    return this.versionSubject.value;
  }

  private getAuditTrailInitialVersion(): boolean {
    const saved = localStorage.getItem('useNewAuditTrail');
    return saved !== null ? JSON.parse(saved) : false;
  }

  setAuditTrailVersion(version: boolean): void {
    this.auditTrailVersionSubject.next(version);
    localStorage.setItem('useNewAuditTrail', JSON.stringify(version));
  }

  get isNewAuditTrailVersion(): boolean {
    return this.auditTrailVersionSubject.value;
  }

  toggleAuditVersion(): void {
    const newVersion = !this.auditTrailVersionSubject.value;
    this.setAuditTrailVersion(newVersion);
  }

  isOneAIAvailable(featureId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._httpService.Post('/api/customer/FeatureLicense/Details', { featureId: featureId }).subscribe({
        next: (res) => {
          if (res?.activeStatus) {
            resolve(true)
          } else {
            resolve(false)
          }
        }, error: () => {
          reject(new Error('false'))
        }
      })
    })
  }
  isOneAIfeatureAvailable(featureId: number, oneAIFeatureId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._globalState.getOneAIFeature(oneAIFeatureId).subscribe({
        next: (feature) => {
          resolve(!!feature?.isActive);
        }, error: () => {
          reject(new Error('false'))
        }
      })
    })
  }

  private getCookie(name: string): string | null {
    const regex = new RegExp('(^| )' + name + '=([^;]+)');
    const match = regex.exec(document.cookie);
    return match ? match[2] : null;
  }

  setRolloutCookie(token: TLoginTokenResponse, comeFromLogin = false): void {
    if (!token.rolloutVersion) return;

    const cookieName = "x-rolloutVersion";
    const existingValue = this.getCookie(cookieName);

    // 🚀 only set & reload if value is different
    if (existingValue !== token.rolloutVersion) {
      const domain = this._config.configData?.sourceUrl;

      // ✅ Step 1: Clear old cookie with expires
      document.cookie =
        `${cookieName}=; domain=.${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=None`;

      // ✅ Step 2: Set new rollout cookie
      const cookieValue =
        `${cookieName}=${token.rolloutVersion}; ` +
        `domain=.${domain}; ` +
        `path=/; ` +
        `Secure; ` +
        `SameSite=None`;

      document.cookie = cookieValue;

      // 🔎 Verify
      const updated = this.getCookie(cookieName);
      if (updated === token.rolloutVersion) {
        if (comeFromLogin) {
          localStorage.removeItem('authlogin');
          localStorage.setItem('tokenRedirectionDetails', JSON.stringify(token));
          this.router.navigateByUrl('/hroneAuth');
        }
        location.reload();
      } else {
        console.warn("Cookie not set correctly, skipping reload.");
      }
    }
  }
  getPublishedDateSet(): void {
    this._globalState.getWorkforceSetupSetting(102).subscribe((res: TWorkforceSetupSettingResponse | null) => {
      if (res) this.showPublishedDate = res.status === 'Y';
    })
  }

  //Replaces special characters with standard equivalents
  sanitizeText(text: string): string {
    if (!text || typeof text !== 'string') {
      return text;
    }

    return text
      .replace(/\u2019/g, "'")  // Replace RIGHT SINGLE QUOTATION MARK with single quote
      .replace(/\u2018/g, "'")  // Replace LEFT SINGLE QUOTATION MARK with single quote
      .replace(/\u201C/g, '"')  // Replace LEFT DOUBLE QUOTATION MARK with double quote
      .replace(/\u201D/g, '"')  // Replace RIGHT DOUBLE QUOTATION MARK with double quote
      .replace(/\u2013/g, '-')  // Replace EN DASH with hyphen
      .replace(/\u2014/g, '-'); // Replace EM DASH with hyphen
  }

  trackEvent(eventName: string, params?: Record<string, any>) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    }
  }

  bakeCookie(cookieName: string, cookieValue: string, cookieExpiry: Date | string): void {
    const now = new Date().getTime();
    let expiryTime: number | undefined = 0;
    expiryTime = this._momentService.parseToDate(cookieExpiry)?.getTime()
    if (expiryTime) {
      const cookieExpiresIn = Math.floor((expiryTime - now) / 1000)
      if (cookieExpiresIn > 0) {
        document.cookie = `${encodeURIComponent(cookieName)}=${encodeURIComponent(cookieValue)}; max-age=${cookieExpiresIn}; path=/; Secure; SameSite=Lax`;
      }
    }
  }

  eatCookie(cookieName: string): string | null {
    const nameEQ = encodeURIComponent(cookieName) + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }

  updateTaxRegimePopUpProps(): void {
    this._globalState.getTaxRegime().pipe(first(), catchError(() => of(null))).subscribe(taxRegime => {
      if (!taxRegime) return;
      if (taxRegime.financialYear) {
        this.dashboardRegimeRes.financialYear = taxRegime.financialYear;
      }
      if (taxRegime.showTaxRegime) {
        this.dashboardRegimeRes.showCrossOnTaxRegime = !taxRegime.taxRegimePopupMandatory;
        this.dashboardRegimeRes.showTaxRegime = true;
      }
      if (taxRegime.taxRegime) {
        this.dashboardRegimeRes.taxRegime = taxRegime.taxRegime;
      }
      if (taxRegime.considerConfirmInvestment) {
        this.dashboardRegimeRes.considerConfirmInvestment = true;
      }
    });
  }
}


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {

    return !!(control && control.invalid && (control.dirty || control.touched));
  }



}
export type TDownloadPromise = {
  promise: Blob, folderPath: string, fileName: string
}

export type TZipDownloadFile = string | { dbFileName: string, receiptCode?: string };

export interface IZipDownloadResponse {
  folders?: { fileList: TZipDownloadFile[], folderName: string }[];
  fileList?: TZipDownloadFile[];
  folderName?: string;
  blobBasePath: string;
  accessToken: string;
  zipName: string;
}

export interface IUserLicenseInfo {
  activeEssUser: number;
  activeProjectUser: number;
  activeUser: number;
  activeWhatsappUser: number;
  goLiveDate: string;
  isGolive: boolean;
  remainingEssUserLicense: number;
  remainingProjectUserLicense: number;
  remainingUserLicense: number;
  remainingWhatsappUserLicense: number;
  totalEssUserLicense: number;
  totalProjectUserLicense: number;
  totalUserLicense: number;
  totalWhatsappUserLicense: number;
}
type TIdentifierKey = 'grade' | 'company' | 'businessUnit' | 'department' | 'subDepartment' |
  'designation' | 'level' | 'region' | 'branch' | 'subBranch';

export interface ICommonsetting {
  menuId: number;
  settingType: string;
  ids: string;
  hasAccess?: boolean;
}
export type PmsSettingType = {
  settingName: string;
  isActive: boolean;
  controlType: string;
  multipleUpdate: boolean;
  controlDataType: null;
  controlDataTypeSize: number;
  generalSettingId: number;
  status: string;
}
export interface RawMenuActionInterface {
  menuId: number;
  actionName: string;
  actionPath: string | null;
  controllerName: string | null;
  actionMethodName: string | null;
  displayName: string | null;
  navigationCode: string;
  isGlobalSearch: boolean;
  isGlobalAction: boolean;
  moduleId: number;
  moduleName: string;
  accessRightId: number;
  dataAccessValidationType: string | null;
  actionCategoryType: number;
  sequenceNo: number;
  isPin: boolean;
  mainMenu: string;
  importIds: string | null;
  actionIds: string | null;
  searchGroupId: number;
  searchGroupName: string | null;
  groupSequenceNo: number;
}
export interface MenuAccessInterface {
  menuName: string;
  sequenceNumber: number;
  menuId: number;
  moduleId: number;
  parentKey: number;
  menuType: string;
  iconImagePath: string;
  navigationPath: string | null;
  activeStatus: string;
  tooltipText: string;
  controlKey: string | null;
  cssClassName: string | null;
  includeMenu: boolean;
  navigationCode: string;
  isPin: boolean;
}
export interface CommonLoginPopupDataInterface {
  requestId: number;
  employeeId: number;
  eventId: number;
  actionId: number;
  serviceEventId: number,
  serviceEventName: string
}
export interface PulseFeedbackDataInterface {
  question: string,
  fromWeightageRatingName: string,
  toWeightageRatingName: string,
  confidentialityMessage: string,
}
export interface TaskDataInterface {
  "inboxTypeId": number,
  "flowId": number,
  "inboxTypeName": string,
  "isMoveToArchive": boolean,
  "isTaskDelegate": boolean,
  "isTaskDelegateExists": boolean,
  "isEditWorkflow": boolean,
  "isBulkApprovalExists": boolean,
  "isBulkApproval": boolean,
  "isMoveToArchiveExists": boolean,
  "isTaskEditWorkflowExists": boolean,
  "isDiscussionEnabledExists": boolean,
  "isDiscussionEnabled": boolean
}
export interface PulseFeedbackDataInterface {
  eventId: number;
  requestId: number;
  employeeId: number;
  actionId: number;
  serviceEventId: number;
  serviceEventName: string;
}
export interface FeedbackDetails {
  logOnUserCode: string;
  domainCode: string;
  logOnUserId: number;
  logOnUserName: string;
  currentUserLogOnType: string;
  categoryId: number;
  subcategoryId: number;
  priorityId: number;
  requestId: number;
  routCourse: string;
  isRcaRequired: boolean;
  categoryName: string;
  subcategoryName: string;
  priorityName: string;
  ticketCode: string;
  employeeId: number;
  feedbackCloseById: string;
  closedByEmployeeCode: string;
  closedByFirstName: string;
  closedByMiddleName: string;
  closedByLastName: string;
  closedByFullName: string;
  closedByPhoto: string;
}
export interface TeamDirectListModel extends EmployeeInformation {
  dateOfJoining: string; // ISO date string
  teamLevel: number;
  lateCount: number;
  delayActionTask: number;
  workingHours: string;
  leaveTaken: number;
  currentOrganizationExperience: string;
  totalExperience: string;
  dateOfBirth: string; // ISO date string
  isProfilePrivate: number; // or boolean if API supports it
  goalStatus: string;
  checked?: boolean;
}
export interface WorkforceImportListModel {
  menuId: number;
  moduleId: number;
  menuName: string;
  sequenceNumber: number;
  moduleName: string;
  importId: number;
  importName: string;
  importDescription: string;
  importType: string;
  maxRecords: number;
  serviceName: string;
  activeStatus: boolean;
  isPin: boolean;
  accessType: string;
  notes: string;
  mainMenu: string;
  noteDetail: string[];
  pageType?: string;
  type?: string;
}
export interface EnterpriseReportMenuListModel {
  menuId: number;
  moduleId: number;
  menuName: string;
  sequenceNumber: number;
  moduleName: string;
  processName: string;
  processId: number;
  reportId: number;
  reportName: string;
  reportDescription: string;
  organizationFilter: boolean;
  scheduler: boolean;
  commonColumn: boolean;
  maxRecords: number;
  serviceName: string;
  sheetHideIndex: string;
  originalFileName: string;
  uploadedFileName: string;
  procedureName: string;
  isPreferred: boolean;
  reportViewType: string;
  isPin: boolean;
  mainMenu: string;
  isWidgetRequired: boolean;
  downloadType: string;
  isPasswordRequired: boolean;
  isDataPreparationRequired: boolean;
  storedProcedureNameToPrepareData: string;
  isExcelUploadRequired: boolean;
  isAskAIEnbled: boolean;
  pageType?: string;
  type?: string;
}
